// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--3ShJW","transMoveUp":"transMoveUp--JYZBi","a":"a--3Nbag","b":"b--3YBFS"};